export const TABLE_COLUMNS = [
  {
    key: "id",
    dataKey: "id",
    title: "Order #",
    sortable: false,
    resizable: false
  },
  {
    key: "name",
    dataKey: "name",
    title: "Product Name",
    sortable: false,
    resizable: false
  },
  {
    key: "amount",
    dataKey: "amount",
    title: "Amount",
    sortable: false,
    resizable: false
  },
  {
    key: "status",
    dataKey: "status",
    title: "Status",
    sortable: false,
    resizable: false
  },
  {
    key: "paymentVendor",
    dataKey: "paymentVendor",
    title: "Payment Vendor",
    sortable: false,
    resizable: false
  },
  {
    key: "createdAt",
    dataKey: "createdAt",
    title: "Date",
    sortable: true,
    resizable: false
  }
];
